export const calculateRank = (...marksArray) => {
    debugger;
    marksArray.sort(function (a, b) { return b.TotalMarks - a.TotalMarks; });
    if (marksArray[0]) marksArray[0].rank = 1;
    for (var i = 1; i < marksArray.length; i++) {
        if (marksArray[i].TotalMarks === marksArray[i - 1].TotalMarks) {
            marksArray[i].rank = marksArray[i - 1].rank;
        } else {
            marksArray[i].rank = i + 1;
        }
    }
    return marksArray
}